import gCard from "../g-card/g-card.vue";

const name = 'g-menu-lateral'
export default {
  name,

  components: { 
    'g-card': gCard
  }, 

  props: { 
    titulofechado: {
      type: String,
      default: 'RESUMO'
    },
    tituloaberto: {
      type: String,
      default: 'RESUMO'
    }
  },

  mounted () { },

  updated () { },

  data () {
    return {
        aberto: false,
     }
  },

  methods: {
      
   },

  computed: { }, 

};